export default "__VITE_ASSET__Dy2Bz2_h__"